<template>
  <v-container fluid class="pa-0 fill-height">
    <Map @select-site="selectSite" />
    <SiteDrawer ref="siteDrawer" />
    <Filters />
    <Logout />
    <map-legend />
  </v-container>
</template>

<script>
import Map from "@/components/Map.vue";
import SiteDrawer from "@/components/SiteDrawer.vue";
import Filters from "@/components/Filters.vue";
import Logout from "@/components/Logout.vue";
import MapLegend from "@/components/MapLegend.vue";

export default {
  name: "Home",

  components: {
    Map,
    SiteDrawer,
    Filters,
    Logout,
    MapLegend
  },

  data() {
    return {
      site: null
    };
  },

  methods: {
    selectSite(site) {
      this.$refs.siteDrawer.setSite(site);
    }
  }
};
</script>
